<template>
  <div class="table">
    <div class="inner">
      <template
        v-for="(content, index) in table"
        :key="content.date"
      >
        <div
          class="card"
        >
          <h3 :class="content.dowEn && content.dowEn">
            {{ content.label }}の天気
          </h3>
          <div class="weather">
            <p :class="content.dowEn && content.dowEn">
              {{ content.date }}
            </p>
            <figure>
              <img
                :src="'https://gvs.weathernews.jp/onebox/img/wxicon/' + content.wx + '.webp'"
                width="109"
                height="80"
                loading="lazy"
                alt=""
              >
              <figcaption class="status pc">
                {{ content.status }}
              </figcaption>
            </figure>
          </div>
          <div class="content">
            <div class="block">
              <div class="row">
                <p class="title">
                  最高
                </p>
                <div class="row__inner">
                  <div class="temp high">
                    <p>{{ content.maxt }}<span>℃</span></p>
                  </div>
                  <figure
                    :data-tooltip="getClothIconTelop(content.daytimeClothRank)"
                  >
                    <img
                      :src="`${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/tops_${content.daytimeClothRank == null ? 'null' : content.daytimeClothRank.toString().padStart(2, '0')}.svg`"
                      :class="{ tomorrow: index > 0 }"
                      alt=""
                      width="41"
                      height="36"
                      loading="lazy"
                    >
                  </figure>
                </div>
              </div>
              <div class="row">
                <p class="title">
                  最低
                </p>
                <div class="row__inner">
                  <div class="temp low">
                    <p>{{ content.mint }}<span>℃</span></p>
                  </div>
                  <figure
                    :data-tooltip="getClothIconTelop(content.nighttimeClothRank)"
                  >
                    <img
                      :src="`${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/tops_${content.nighttimeClothRank == null ? 'null' : content.nighttimeClothRank.toString().padStart(2, '0')}.svg`"
                      :class="{ tomorrow: index > 0 }"
                      alt=""
                      width="41"
                      height="36"
                      loading="lazy"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
          <div class="info">
            <div class="row">
              <p class="title">
                降水
              </p>
              <div class="row__inner prec">
                <figure>
                  <img
                    :src="`${runtimeConfig.public.gvsUrl}/onebox/img/common/icon_prec_${calcUmbrellaIndex(content.pop).toString().padStart(2, '0')}.svg`"
                    alt=""
                    width="45"
                    height="45"
                    loading="lazy"
                  >
                </figure>
                <p class="value">
                  {{ content.pop }}<span class="unit">%</span>
                </p>
              </div>
            </div>
            <div class="row">
              <p class="title">
                風
              </p>
              <div class="row__inner">
                <div
                  class="wind"
                  :data-rank="content.wrank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="15"
                    viewBox="0 0 11 15"
                    :data-rank="content.wrank"
                    :style="`transform: rotate(calc(1deg * ${content.wdir_360 === null ? 0 : content.wdir_360}))`"
                  >
                    <path
                      d="M9.91706 1.33286L5.48529 13.7418L1.05353 1.33286L5.31805 5.17093L5.48529 5.32145L5.65253 5.17093L9.91706 1.33286Z"
                      stroke="#333333"
                      stroke-width="0.5"
                    />
                  </svg>
                  <p class="value">
                    {{ content.wspd }}<span class="unit">m/s</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <p
      class="legend"
      @click="$emit('open-modal')"
    >
      服装・傘アイコンの説明
    </p>
  </div>
</template>

<script setup>
defineProps({
  table: {
    type: Array,
    required: true
  }
})
defineEmits(['open-modal'])

const runtimeConfig = useRuntimeConfig()
</script>

<style lang="scss" scoped>
.table {
  position: relative;
  width: 100%;
  height: 214px;
  padding-bottom: 2px;
  &::-webkit-scrollbar {
    display: none;
  }
  .inner {
    display: flex;
    justify-content: center;
    gap: 5px;
    width: 100%;
  }
  .card {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    height: 200px;
    padding: 5px min(calc(100 / 375 * 3vw), 5px);
    border: 1px solid #DFE4F0;
    border-radius: 8px;
    background-color: #f9f9f9;
    h3 {
      gap: 2px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: bold;
      line-height: 1em;
      &.sat {
        color: #0060FF;
      }
      &.sun {
        color: #FF3000;
      }
      span {
        font-size: 13px;
      }
    }
    .weather {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-inline: auto;
      figure {
        display: flex;
        align-items: center;
        height: 30px;
        text-align: center;
        img {
          width: auto;
          height: 100%;
        }
      }
      .status {
        color: #606060;
        font-size: 12px;
        font-weight: 300;
        line-height: 14px;
        text-align: center;
        white-space: nowrap;
        margin-left: 5px;
      }
      p {
        flex: 1;
        color: #333;
        text-align: center;
        font-size: 15px;
        font-weight: 600;
        line-height: 1.3em;
        &.sat {
          color: #0060FF;
        }
        &.sun {
          color: #FF3000;
        }
      }
    }
    .content {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      gap: 6px;
      width: 100%;
    }
    .block {
      display: flex;
      flex-direction: column;
      border-radius: 8px;
      width: 100%;
    }
    .row {
      display: flex;
      &__inner {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        flex: 1;
        padding: 5px;
        background-color: #FFF;
        figure {
          position: relative;
          height: 37px;
          img {
            width: auto;
            height: 100%;
          }
          &:hover {
            &::after {
              opacity: 1;
            }
          }
          &::after {
            position: absolute;
            bottom: 105%;
            left: -50%;
            display: block;
            padding: 7px 8px 5px;
            background: #000;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 300;
            color: #fff;
            white-space: nowrap;
            content: attr(data-tooltip);
            opacity: 0;
            z-index: 10;
            transition: opacity .2s ease-in-out;
            pointer-events: none;
            visibility: hidden;
          }
          &[data-tooltip]:hover::after {
            opacity: 1;
            visibility: visible;
          }
          &:has(.tomorrow) {
            &::after {
              left: auto;
              right: -10px;
            }
          }
          &:hover::after,
          &:focus::after,
          &:active::after {
            opacity: 1;
          }
        }
        &:has(.wind) {
          justify-content: center;
          padding-block: 2px;
          gap: 3px;
        }
      }
      &:not(:first-child) {
        border-top: 1px solid #DFE4F0;
      }
      &:is(.info *) {
        flex: 1;
        border-top: none;
        border-radius: 8px;
        overflow: hidden;
      }
      &:first-child {
        .title {
          border-top-left-radius: 8px;
        }
        .row__inner {
          border-top-right-radius: 8px;
        }
      }
      &:last-child {
        .title {
          border-bottom-left-radius: 8px;
        }
        .row__inner {
          border-bottom-right-radius: 8px;
        }
      }
    }
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      background-color: #EEF1F8;
      color: #303030;
      text-align: center;
      font-size: 12px;
      font-weight: 300;
      line-height: 14px;
    }
    .temp {
      display: flex;
      align-items: center;
      gap: 5px;
      p {
        min-width: 32px;
        font-size: 15px;
        font-weight: 600;
        line-height: 14px;
        text-align: right;
        span {
          font-size: 13px;
        }
      }
      &.high {
        p {
          color: #F64D00;
        }
      }
      &.low {
        p {
          color: #0075F3;
        }
      }
    }
    .info {
      display: flex;
      gap: 3px;
      width: 100%;
    }
    .prec {
      flex-direction: column;
      align-items: center;
      padding-block: 2px;
      gap: 0;
      figure {
        height: 18px;
        img {
          vertical-align: baseline;
        }
      }
      .value {
        color: #303030;
        font-size: 12px;
        font-weight: 700;
        line-height: 14px;
      }
      .unit {
        font-size: 12px;
      }
    }
    .wind {
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        font-size: 13px;
        line-height: 15px;
      }
      .title {
        padding: 4px 8px;
        border-radius: 100vmax;
        background-color: #eef1f8;
      }
      svg {
        &[data-rank='0'] {
          fill: #ffffff;
        }
        &[data-rank='1'] {
          fill: #03aeef;
        }
        &[data-rank='2'] {
          fill: #05ad50;
        }
        &[data-rank='3'] {
          fill: #febf00;
        }
        &[data-rank='4'] {
          fill: #e86200;
        }
        &[data-rank='5'] {
          fill: #fe0000;
        }
      }
      .value {
        font-size: 12px;
        font-weight: 700;
        line-height: 14px;
        .unit {
          font-size: 10px;
        }
      }
    }
  }
  .legend {
    position: absolute;
    bottom: -2px;
    right: 0;
    padding-left: 15px;
    background-image: url('~/assets/images/common/icon_info.svg');
    background-position: left center;
    background-repeat: no-repeat;
    background-size: 12px;
    color: #303030;
    font-size: 12px;
    line-height: 1em;
  }
  @media screen and (max-width: 929px) {
    .pc {
      display: none !important;
    }
    .sp {
      display: block !important;
    }
  }
  @media screen and (min-width: 930px) {
    gap: 10px;
    .card {
      padding: 6px 15px;
      align-items: flex-start;
      h3 {
        flex-direction: row;
        gap: 10px;
        span {
          font-size: 14px;
        }
      }
    }
  }
  @media (any-hover: hover) {
    .legend {
      cursor: pointer;
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
  }
}
</style>
